import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description:
      'Contains Employee-Skill: The association(s) between an Employee and a Skill. An Employee may have multiple Skills and Skills can be associated with multiple employees.',
    name: 'Employee-Skills',
    partialId: PartialId.Standard.create('employee_skills'),
  },
  type: core.quiver.Resource.Type.DmsDimension,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsDimension>
